__turbopack_context__.v({
  "__categories-list": "submission-history-module-scss-module__6t_Mma____categories-list",
  "__categories-list-item": "submission-history-module-scss-module__6t_Mma____categories-list-item",
  "__edit-button": "submission-history-module-scss-module__6t_Mma____edit-button",
  "__groups-list": "submission-history-module-scss-module__6t_Mma____groups-list",
  "__groups-list-item": "submission-history-module-scss-module__6t_Mma____groups-list-item",
  "__icon-container": "submission-history-module-scss-module__6t_Mma____icon-container",
  "__item": "submission-history-module-scss-module__6t_Mma____item",
  "__link-contents": "submission-history-module-scss-module__6t_Mma____link-contents",
  "__list-header": "submission-history-module-scss-module__6t_Mma____list-header",
  "__list-subheader": "submission-history-module-scss-module__6t_Mma____list-subheader",
  "__no-items": "submission-history-module-scss-module__6t_Mma____no-items",
  "__question-name": "submission-history-module-scss-module__6t_Mma____question-name",
  "__submission-name": "submission-history-module-scss-module__6t_Mma____submission-name",
  "__submissions-list": "submission-history-module-scss-module__6t_Mma____submissions-list",
  "__submissions-list-item": "submission-history-module-scss-module__6t_Mma____submissions-list-item",
  "__text-container": "submission-history-module-scss-module__6t_Mma____text-container",
  "__times-list": "submission-history-module-scss-module__6t_Mma____times-list",
  "__times-list-item": "submission-history-module-scss-module__6t_Mma____times-list-item",
  "submission-history": "submission-history-module-scss-module__6t_Mma__submission-history",
});
